import React from 'react';

import { Modal, Tag, message } from 'antd';

import fetch from './../fetch';
import utils from './../../utils';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    // {type: 'selection'},
    { key: '$index', label: '序号', width: 80 },
    { key: 'orgName', label: '部门名称', width: 120 },
    { key: 'targetName', label: '指标', width: 200 },
    { key: 'monthId', label: '最新提交月份', width: 100, render: (value) => value ? value + '月份' : '' },
    { key: 'score', label: '部门评价分', width: 100 },
    { key: 'todoCount', label: '部门待评次数', width: 120 },
    { key: 'hasCount', label: '部门已评次数', width: 120 },
    { key: 'employeeName', label: '录入人', width: 120 },
    { key: 'termName', label: '学期', width: 120 },
]);

const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('/dtme/result/queryGenerate?' + params.join('&'), keywords)
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.orgId,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if (d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

const get = (id) => {
    return fetch.get(`dtme/result/get/${id}`)
}

const update = (id, domain) => {
    return fetch.post(`dtme/target/update/${id}`, domain)
}

const remove = (ids) => {
    return fetch.post(`dtme/result/remove`, ids)
}


const getEnterContent = (param) => {
    return fetch.post(`dtme/result/getEnterContent`, param)
}

const deleteFile = (param) => {
    return fetch.post(`dtme/result/delete`, param)
}

const insert = (param) => {
    return fetch.post(`dtme/result/insert`, param)
}

const getCompletion = (param) => {
    return fetch.post(`dtme/result/getCompletion`, param)
}

const back = (ids) => {
    return fetch.post(`dtme/result/back`, ids)
}

const querySearchMonths = () => {
    return fetch.get(`dtme/result/getMonths`, {})
}

export default {
    columns,
    querySearch,
    getEnterContent,
    upload: `${fetch.base}dtme/result/file`,
    deleteFile,
    insert,
    onSelect,
    setRefresh,
    getSelection,
    remove,
    getCompletion,
    get,
    back,
    querySearchMonths
}